export default __webpack_public_path__ + "static/media/micael.8bcdd175.jfif";